export default __webpack_public_path__ + "static/media/heart2heart.2861ba42.jpg";